module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"errors":{"failRetrievingDocument":"There were errors while retrieving the help content"}},"es":{"errors":{"failRetrievingDocument":"Se encontraron errores en la recuperación del contenido de ayuda"}}}')
  delete Component.options._Ctor
}
